import {Pipe, PipeTransform} from '@angular/core';
import {environment} from "../../../../../../environments/environment";

@Pipe({
  name: 'employeePictureUrl',
})
export class EmployeePictureUrlPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value || value.trim() === '') {
      return '';
    }
    
    // Nettoyer l'URL de base
    let baseUrl = environment.apiUrl;
    if (baseUrl.endsWith('/')) {
      baseUrl = baseUrl.slice(0, -1);
    }
    
    // Utiliser l'endpoint images pour récupérer les images
    const url = `${baseUrl}/images/${value}`;
    return url;
  }
}
